<template>
  <div 
      v-if="view === 'map'" 
      class="wg-row com-anm22-food-table-map-el map-elem" 
      :style="{ top: (4 + 84 * table.posY ) + 'px', left: (4 + 94 * table.posX ) + 'px', backgroundColor }"
      @click="tableClick"
  >
    <div class="vertical-height-div" style="height:2px;"></div>
    <div class="com-anm22-app-text-l">{{ table.name }}</div>
    <div class="vertical-height-div" style="height:2px;"></div>
    <div v-if="lastOrder.tableAlias" class="com-anm22-app-text-l">{{ lastOrder.tableAlias }}</div>
    <div class="vertical-height-div" style="height:2px;"></div>
    <div v-if="isOccupied" class="com-anm22-app-text-l">{{ elapsed + ' min' }}</div>
    <div v-if="isOccupied" class="com-anm22-app-text-l" style="position:absolute;bottom:4px;left:2px;">
      {{ lastOrder.covers[0].length }}
    </div>
    <div v-if="isOccupied && license.printSequences" class="com-anm22-app-text-l" style="position:absolute;bottom:4px;right:2px;">
      {{ sequenceString }}
    </div>
  </div>
  <div 
      v-else 
      class="wg-row list-elem" 
      :style="{ backgroundColor }"
      @click="tableClick"
  >
    <div class="wg-col wg-xs-8">
      <div class="com-anm22-app-text-l">{{ table.name }}</div>
    </div>
    <div v-if="lastOrder.tableAlias" class="wg-col wg-xs-4">
      <div class="com-anm22-app-text-l">{{ lastOrder.tableAlias }}</div>
    </div>
    <div class="wg-col wg-xs-1">
      <div class="com-anm22-app-text-l">
        {{ $anm22.strLang(lang, 'C: ', 'C: ') + lastOrder.covers[0].length }}
      </div>
    </div>
    <div class="wg-col wg-xs-1">
      <div v-if="license.printSequences" class="com-anm22-app-text-l" style="margin-right:10px;">
        {{ $anm22.strLang(lang, 'S: ', 'S: ') + sequenceString }}
      </div>
    </div>
    <div class="wg-col wg-xs-2">
      <div v-if="lastOrder.printedSequenceTime" class="com-anm22-app-text-l">
        {{ elapsed + ' min' }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  props: {
    view: {
      type: String,
      default: 'map'
    },
    table: Object,
    freeFn: Function,
    occupiedFn: Function
  },
  data() {
    return {
      colors: {
        free: '#00C853',
        empty: '',
        occupied: '#FF5722',
        last_sequence: '',
        bill: '#FF9322',
      },
      labels: {
        free: ['Free', 'Libero'],
        empty: ['Waiting', 'In attesa'],
        occupied: ['Occupied', 'Occupato'],
        last_sequence: ['Last sequence', 'Ultima portata'],
        bill: ['Bill requested', 'Pre-conto'],
      }
    }
  },
  computed: {
    ...mapState({
      lang: state => state.lang,
      selectedLicense: state => state.licenseSelected
    }),
    license() {
      return this.$store.getters['foodLicenses/getByHash'](this.selectedLicense);
    },
    // info() {
    //   return this.table.info;
    // },
    isOccupied() {
      return !!this.table.isOccupied;
    },
    lastOrder() {
      return this.isOccupied ? this.$store.getters['foodOrders/get'](this.table.isOccupied) : {};
    },
    backgroundColor() {
      return this.isOccupied ? (this.lastOrder.nonFiscalPrinted ? this.colors['bill'] : this.colors['occupied']) : this.colors['free'];
    },
    elapsed() {
      if(this.isOccupied) {
        return Math.floor(this.$moment.duration(
          this.$moment().diff(this.$moment.unix(this.lastOrder.printedSequenceTime))
        ).asMinutes());
      } else {
        return null;
      }
    },
    sequenceString() {
      if(this.isOccupied) {
        return this.lastOrder.printedSequence + '/' + this.lastOrder.maxSequence;
      } else {
        return "0/0";
      }
    }
  },
  methods: {
    tableClick() {
      if(this.isOccupied) {
        this.occupiedFn(this.lastOrder);
      } else {
        this.freeFn(this.table);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.map-elem {
  position: absolute;
  font-weight: bold;
  color: #fff;
  // Content
  flex-direction:column;
  justify-content:flex-start;
  align-items:center;
}
.list-elem {
  color: #fff;
  font-weight: bold;
  border-radius: 4px;
  box-shadow: 0 2px 5px 0 #ccc;
  padding: 5px;
  margin: 0 0 5px 0;
  cursor: pointer;
}
</style>
